export const GATEWAY_CONFIG_DATATYPE: string = 'CloudplugLightDataConfigurationImpl';
export const PARITY: string[] = ['None', 'Odd', 'Even'];
export const BAUD_RATES: number[] = [1200, 2400, 4800, 9600, 19200, 38400, 57600, 115200];
export const DEFAULT_BAUD_RATE: number = 19200;
export const DEFAULT_PARITY: number = 0;
export const DEFAULT_DATA_BITS: number = 8;
export const DEFAULT_STOP_BITS: number = 1;
export const ADC_TYPE_OF_DATA: string = 'ADC';
export const MODBUS_TYPE_OF_DATA: string = 'MODBUS';
export const MAX_NUMBER_OF_REGISTERS: number = 200;
export const HYSTERESIS_RANGE_MIN = 10;
export const HYSTERESIS_RANGE_MAX = 1000;